import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail, fmtMoney } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";

// Add-address $50 refunds that became due — stays listed until an admin marks it issued.
export function RefundsDue() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = useCallback(() => {
    api.get("/admin/refunds-due").then(({ data }) => setRows(data.refunds_due || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const markIssued = async (id) => {
    setBusy(id);
    try {
      await api.post(`/admin/refunds-due/${id}/issued`, {});
      toast.success("Refund marked issued");
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not update");
    } finally { setBusy(null); }
  };

  if (!rows.length) return null;
  return (
    <div data-testid="refunds-due" className="rounded-xl border border-amber-200 bg-amber-50 p-4">
      <p className="font-semibold text-amber-900">Refunds due ({rows.length})</p>
      <p className="text-xs text-amber-700">Add-address $50 (1-attempt) add-ons with no documented attempt. Issue the refund, then mark it done.</p>
      <div className="mt-3 space-y-2">
        {rows.map((r) => (
          <div key={r.order_id} data-testid="refund-due-row" className="flex items-center justify-between gap-3 rounded-lg border border-amber-200 bg-white px-3 py-2 text-sm">
            <span>#{r.job_number} · {r.client_name || "—"} · <span className="font-semibold">{fmtMoney(r.amount)}</span></span>
            <Button data-testid="refund-mark-issued-btn" size="sm" variant="outline" disabled={busy === r.order_id} onClick={() => markIssued(r.order_id)}>
              <RotateCcw className="mr-1 h-4 w-4" /> Mark issued
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
